import { Injectable, Inject } from "@angular/core";
import { environment } from "../../../environments/environment";
 
declare var AWSCognito: any;
declare var AWS: any;

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;    
}

export interface cognitoCallbackPassword {
    cognitoCallbackPassword(message: string, result: any): void;   
}

export interface callbackWithParam {
    callbackWithParam(result: any): any;
}

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
    callback(): void;
    callbackWithParam(result: any): void;
}

@Injectable()
export class CognitoUtil {

    public static _REGION = environment.region;

    public static _IDENTITY_POOL_ID = environment.identityPoolId;
    public static _USER_POOL_ID = environment.userPoolId;
    public static _CLIENT_ID = environment.clientId;

    public static _POOL_DATA = {
        UserPoolId: CognitoUtil._USER_POOL_ID,
        ClientId: CognitoUtil._CLIENT_ID
    };


    public static getAwsCognito(): any {
        return AWSCognito
    }

    getUserPool() {
        return new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(CognitoUtil._POOL_DATA);
    }

    getCurrentUser() {
        return this.getUserPool().getCurrentUser();
    }


    getCognitoIdentity(): string {
        return AWS.config.credentials.identityId;
    }

    getAccessToken(callback: Callback): void {
        if (callback == null) {
            throw("CognitoUtil: callback in getAccessToken is null...returning");
        }
        if (this.getCurrentUser() != null)
            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    // console.log("CognitoUtil: Can't set the credentials:" + err);
                    callback.callbackWithParam(null);
                }

                else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getAccessToken().getJwtToken());
                    }
                }
            });
        else
            callback.callbackWithParam(null);
    }

    getIdToken(callback: Callback): void {
        if (callback == null) {
            throw("CognitoUtil: callback in getIdToken is null...returning");
        }
        if (this.getCurrentUser() != null)
            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    // console.log("CognitoUtil: Can't set the credentials:" + err);
                    callback.callbackWithParam(null);
                }
                else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getIdToken().getJwtToken());
                    } else {
                      //  console.log("CognitoUtil: Got the id token, but the session isn't valid");
                    }
                }
            });
        else
            callback.callbackWithParam(null);
    }

    getRefreshToken(callback: Callback): void {
        if (callback == null) {
            throw("CognitoUtil: callback in getRefreshToken is null...returning");
        }
        if (this.getCurrentUser() != null)
            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    // console.log("CognitoUtil: Can't set the credentials:" + err);
                    callback.callbackWithParam(null);
                }

                else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getRefreshToken());
                    }
                }
            });
        else
            callback.callbackWithParam(null);
    }

    getRefreshSession(callback: Callback): void {
        //  var keyPrefix = 'CognitoIdentityServiceProvider.' + CognitoUtil._CLIENT_ID + '.' + JSON.parse(localStorage.getItem('user')).email;
	    //  var refreshTokenKey = keyPrefix + '.refreshToken';
        // let refreshTokenObj = {};
	    // localStorage.getItem(refreshTokenKey);// = localStorage.getItem(refreshTokenKey);


        if (callback == null) {
            throw("CognitoUtil: callback in getRefreshToken is null...returning");
        }
        if (this.getCurrentUser() != null) {
            let refreshToken = JSON.parse(localStorage.getItem('refreshToken'));
            this.getCurrentUser().refreshSession(refreshToken ,function (err, session) {
                if (err) {
                    // console.log("CognitoUtil: Can't set the credentials:" + err);
                    callback.callbackWithParam(null);
                }

                else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session);
                    }
                }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    refresh(): void {
        this.getCurrentUser().getSession(function (err, session) {
            if (err) {
                // console.log("CognitoUtil: Can't set the credentials:" + err);
            }

            else {
                if (session.isValid()) {
                   // console.log("CognitoUtil: refreshed successfully");
                } else {
                   // console.log("CognitoUtil: refreshed but session is still not valid");
                }
            }
        });
    }
}

@Injectable()
export class UserRegistrationService {

    constructor(@Inject(CognitoUtil) public cognitoUtil: CognitoUtil) {

    }

    adminCreateUser(user, callback: CognitoCallback): void {
        //console.log("UserRegistrationService: user is " + user);

        let attributeList = [];

        let dataEmail = {
            Name: 'email',
            Value: user.email
        };
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail));
        
        let dataFirstname = {
            Name: 'custom:firstname',
            Value: user.firstName
        };
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataFirstname));
        
        if(user.lastName) {
            let dataLastname = {
                Name: 'custom:lastname',
                Value: user.lastName
            };
            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataLastname));        
        }

        if(user.phoneNumber) {
            let dataPhoneNumber = {
                Name : 'custom:phonenumber',
                Value : user.phoneNumber
            };
            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataPhoneNumber));
        }

        let dataUserType = {
            Name : 'custom:accounttype',
            Value : user.userType
        };
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataUserType));
        
        if(user.status) {
            let dataStatus = {
                Name : 'custom:status',
                Value : user.status
            };
            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataStatus));
        }

        let dataUserId = {
            Name: 'custom:userid',
            Value: user.uniqueId
        };
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataUserId));
        
        let password = (user.password != "") ? user.password : "M3s@2017" ;

        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });

        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: user.email, /* required */
            DesiredDeliveryMediums: ['EMAIL', /* more items */],
            ForceAliasCreation: false,
            /*MessageAction: 'RESEND',*/
            TemporaryPassword: password,
            UserAttributes: attributeList,
            ValidationData: [
            {
              Name: 'email', /* required */
              Value: ''
            }]
        };

        client.adminCreateUser(params, function(err, data) {
            if (err) {
                //console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {
                //console.log(data);           // successful response
                let groupParams = {
                    UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
                    Username: user.email, /* required */
                    GroupName: user.userType, /* required */
                };

                client.adminAddUserToGroup(groupParams, function(err, data) {
                    if (err) {
                       // console.log(err, err.stack); // an error occurred
                        callback.cognitoCallback(err.message, null);
                    } else {
                        callback.cognitoCallback(null, data);
                    } 
                });
            } 
        });
    }

    confirmRegistration(username: string, confirmationCode: string, callback: CognitoCallback): void {

        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, result);
            }
        });
    }

    resendCode(username: string, callback: CognitoCallback): void {
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, result);
            }
        });
    }
}

@Injectable()
export class UserManageService {
    employeeUpdate = 0;

    constructor(@Inject(CognitoUtil) public cognitoUtil: CognitoUtil) { }

    listUsersInGroups(groupName: string, limit: number, nextToken: string, callParams: callbackWithParam) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
          GroupName: groupName, /* required */
          UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
          /*Limit: limit,
          NextToken: nextToken */
        };

        client.listUsersInGroup(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                //return err;
                callParams.callbackWithParam(null);
            } else {
                //console.log(data);         // successful response 
                callParams.callbackWithParam(data);
            }   
        });
    }

    getUser(callParams: callbackWithParam) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            AccessToken: localStorage.getItem("accessToken")
        };

        client.getUser(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                return err;
            } else {
                callParams.callbackWithParam(data);
                //console.log(data);           // successful response 
            }   
        });
    }

    updateUser(user, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let attributeList = [];

        if(user.firstName != "") {
            let dataFirstname = {
                Name: 'custom:firstname',
                Value: user.firstName
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataFirstname));
        }
        
        if(user.lastName != "") {
            let dataLastname = {
                Name: 'custom:lastname',
                Value: user.lastName
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataLastname));
        }

        if(user.phoneNumber != "") {
            let dataPhoneNumber = {
                Name : 'custom:phonenumber',
                Value : user.phoneNumber
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataPhoneNumber));
        }

        let params = {
            UserAttributes: attributeList,
            AccessToken: localStorage.getItem("accessToken")
        };

        client.updateUserAttributes(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, data);
                // console.log(data);           // successful response 
            }   
        });
    }

    updatePassword(user, callback: cognitoCallbackPassword) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            PreviousPassword: user.currentPassword, /* required */
            ProposedPassword: user.newPassword, /* required */
            AccessToken: localStorage.getItem("accessToken")
        };

        client.changePassword(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallbackPassword(err.message, null);
            } else {                
                //console.log(data);           // successful response 
                callback.cognitoCallbackPassword(null, data);
            }   
        });
    }

    adminGetUser(email: string, callParams: callbackWithParam) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: email, /* required */
        };

        client.adminGetUser(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callParams.callbackWithParam(null);
            } else {
                callParams.callbackWithParam(data);
                //console.log(data);           // successful response 
            }   
        });
    }

    adminUpdateUser(user, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let attributeList = [];

        if(user.firstname != "") {
            let dataFirstname = {
                Name: 'custom:firstname',
                Value: user.firstname
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataFirstname));
        }
        
        if(user.lastname != "") {
            let dataLastname = {
                Name: 'custom:lastname',
                Value: user.lastname
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataLastname));
        }

        if(user.designation != "") {
            let dataDesignation = {
                Name: 'custom:designation',
                Value: user.designation
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataDesignation));
        }

        if(user.phoneNumber != "") {
            let dataPhoneNumber = {
                Name : 'custom:phoneNumber',
                Value : user.phonenumber
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataPhoneNumber));
        }

        if(user.shift != "") {
            let dataShift = {
                Name: 'custom:shift',
                Value: user.shift
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataShift));
        }

        if(user.status != "") {
            let dataStatus = {
                Name : 'custom:status',
                Value : user.status
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataStatus));
        }

        let params = {
            UserAttributes: attributeList,
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: user.email, /* required */
        };

        client.adminUpdateUserAttributes(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {
                let changeStatusParams = {
                    UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
                    Username: user.email, /* required */
                };

                if(user.status == 'Active') {                    
                    client.adminEnableUser(changeStatusParams, function(err, data) {
                        if (err) {
                            // console.log(err, err.stack); // an error occurred
                            callback.cognitoCallback(err.message, null);
                        } else {                
                            //console.log(data);           // successful response 
                            callback.cognitoCallback(null, data);
                        }   
                    });
                } else {
                    client.adminDisableUser(changeStatusParams, function(err, data) {
                        if (err) {
                            // console.log(err, err.stack); // an error occurred
                            callback.cognitoCallback(err.message, null);
                        } else {                
                            //console.log(data);           // successful response 
                            callback.cognitoCallback(null, data);
                        }   
                    });
                }
            }   
        });
    }

    adminUpdateUserStatus(user, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let attributeList = [];

        if(user.status != "") {
            let dataStatus = {
                Name : 'custom:status',
                Value : user.status
            };

            attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataStatus));
        }

        let params = {
            UserAttributes: attributeList,
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: user.email, /* required */
        };

        client.adminUpdateUserAttributes(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {
                let changeStatusParams = {
                    UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
                    Username: user.email, /* required */
                };

                if(user.status == 'Active') {
                    client.adminEnableUser(changeStatusParams, function(err, data) {
                        if (err) {
                            // console.log(err, err.stack); // an error occurred
                            callback.cognitoCallback(err.message, null);
                        } else {                
                            //console.log(data);           // successful response 
                            callback.cognitoCallback(null, data);
                        }   
                    });
                } else {
                    client.adminDisableUser(changeStatusParams, function(err, data) {
                        if (err) {
                            // console.log(err, err.stack); // an error occurred
                            callback.cognitoCallback(err.message, null);
                        } else {                
                            //console.log(data);           // successful response 
                            callback.cognitoCallback(null, data);
                        }   
                    });
                }
            }   
        });
    }

    changeDeleteStatusUser(email: string, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let attributeList = [];

        let dataDeleteStatus = {
            Name : 'custom:deleted',
            Value : '1'
        };

        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataDeleteStatus));
       
        let params = {
            UserAttributes: attributeList,
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: email, /* required */
        };

        client.adminUpdateUserAttributes(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {                
                //console.log(data);           // successful response 
                let changeStatusParams = {
                    UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
                    Username: email, /* required */
                };

                client.adminDisableUser(changeStatusParams, function(err, data) {
                    if (err) {
                        // console.log(err, err.stack); // an error occurred
                        callback.cognitoCallback(err.message, null);
                    } else {                
                        //console.log(data);           // successful response 
                        callback.cognitoCallback(null, data);
                    }   
                });
            }   
        });
    }

    deleteUser(email: string, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: email, /* required */
        };

        client.adminDeleteUser(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {                
                //console.log(data);           // successful response 
                callback.cognitoCallback(null, data);
            }   
        });
    }

    adminResetUserPassword(email: string, callback: CognitoCallback) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let params = {
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: email, /* required */
        };

        client.adminResetUserPassword(params, function(err, data) {
            if (err) {
                // console.log(err, err.stack); // an error occurred
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, data);
                // console.log(data);           // successful response 
            }   
        });
    }

    adminEmailVerified(email: string) {
        AWS.config = new AWS.Config();
        // AWS.config.accessKeyId = environment.accessKeyId;
        // AWS.config.secretAccessKey = environment.secretAccessKey;
        AWS.config.region = CognitoUtil._REGION;

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: logins
        });


        let CognitoIdentityServiceProvider = AWS.CognitoIdentityServiceProvider;
        let client = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

        let userAttributeParams = {
        UserAttributes: [{
                  Name: "email_verified",
                  Value: "true"
                }
            ],
            UserPoolId: CognitoUtil._USER_POOL_ID, /* required */
            Username: email /* required */
        };

        client.adminUpdateUserAttributes(userAttributeParams, function(err) {
            if (err) {
                // console.log(err, err.stack)
                //console.log('email not verified error!');
            } else {
                //console.log('email verified Success!');
            }
        }); 
    }
}

@Injectable()
export class UserLoginService {

    constructor(public cognitoUtil: CognitoUtil) {
    }

    authenticate(username: string, password: string, callback: CognitoCallback) {        
        // console.log("UserLoginService: starting the authentication")
        // Need to provide placeholder keys unless unauthorised user access is enabled for user pool
       // AWSCognito.config.update({accessKeyId: environment.accessKeyId, secretAccessKey: environment.secretAccessKey })

        let authenticationData = {
            Username: username,
            Password: password,
        };
        let authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);

        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };
        let attributesData = {
            Name : "email",
            Value : username
        };
      //  console.log("UserLoginService: Params set...Authenticating the user");
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
        //console.log("UserLoginService: config is " + AWS.config);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                var logins = {}
                logins['cognito-idp.' + CognitoUtil._REGION + '.amazonaws.com/' + CognitoUtil._USER_POOL_ID] = result.getIdToken().getJwtToken();
                // Add the User's Id Token to the Cognito credentials login map.
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID,
                    Logins: logins
                });
                AWS.config.region = CognitoUtil._REGION;
                //console.log("UserLoginService: set the AWS credentials - " + JSON.stringify(AWS.config.credentials));
                //console.log("UserLoginService: set the AWSCognito credentials - " + JSON.stringify(AWSCognito.config.credentials));
                AWS.config.credentials.get(function (err) {
                    if (!err) {
                       // console.log('success');
                        callback.cognitoCallback(null, result);
                    } else {
                       // console.log('onsuccess error');
                        callback.cognitoCallback(err.message, null);
                    }
                });

            },            
            onFailure: function (err) {
                //console.log('onfailure');
                callback.cognitoCallback(err.message, null);
            },
            newPasswordRequired: function(attributesData, requiredAttributes) {
                // User was signed up by an admin and must provide new 
                // password and required attributes, if any, to complete 
                // authentication.

                // userAttributes: object, which is the user's current profile. It will list all attributes that are associated with the user. 
                // Required attributes according to schema, which don’t have any values yet, will have blank values.
                // requiredAttributes: list of attributes that must be set by the user along with new password to complete the sign-in.

                
                // Get these details and call 
                // newPassword: password that user has given
                // attributesData: object with key as attribute name and value that the user has given.
                cognitoUser.completeNewPasswordChallenge(password, attributesData, this)
            },
        });
    }

    forgotPassword(username: string, callback: CognitoCallback) {
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.forgotPassword({
            onSuccess: function (result) {

            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
            inputVerificationCode() {
                callback.cognitoCallback(null, null);
            }
        });
    }

    confirmNewPassword(email: string, verificationCode: string, password: string, callback: CognitoCallback) {
        let userData = {
            Username: email,
            Pool: this.cognitoUtil.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmPassword(verificationCode, password, {
            onSuccess: function (result) {
                callback.cognitoCallback(null, result);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            }
        });
    }

    logout() {
        //console.log("UserLoginService: Logging out");
        //this.cognitoUtil.getCurrentUser().signOut();
        let cognitoUser = this.cognitoUtil.getCurrentUser();
        cognitoUser.signOut();
    }

    isAuthenticated(callback: LoggedInCallback) {
        if (callback == null)
            throw("UserLoginService: Callback in isAuthenticated() cannot be null");

        let cognitoUser = this.cognitoUtil.getCurrentUser();

        if (cognitoUser != null) {
            //console.log(cognitoUser);
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    // console.log("UserLoginService: Couldn't get the session: " + err, err.stack);
                    callback.isLoggedIn(err, false);
                }
                else {
                  //  console.log("UserLoginService: Session is " + session.isValid());
                    callback.isLoggedIn(err, session.isValid());
                }
            });
        } else {
           // console.log("UserLoginService: can't retrieve the current user");
            callback.isLoggedIn("Can't retrieve the CurrentUser", false);
        }
    }

}

@Injectable()
export class UserParametersService {

    constructor(public cognitoUtil: CognitoUtil) {
    }

    getParameters(callback: Callback) {
        let cognitoUser = this.cognitoUtil.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                   // console.log("UserParametersService: Couldn't retrieve the user");
                }
                else {
                    cognitoUser.getUserAttributes(function (err, result) {
                        if (err) {
                            // console.log("UserParametersService: in getParameters: " + err);
                        } else {
                            callback.callbackWithParam(result);
                        }
                    });
                }

            });
        } else {
            callback.callbackWithParam(null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cognito/cognito.service.ts